import React, { useEffect, useState,useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { addDoc, collection } from "firebase/firestore";
import { analytics, db } from "../../config/firebase";
import { auth } from "../../config/firebase";
import "./cart.css";


import {
  clearCart,
  getCartTotal,
  removeItem,
  updateQuantity,
} from "../../redux/CartSlice";
import Heading from "../../common/Heading";
import { useNavigate } from "react-router-dom";
import ScrollToTop from "../../components/ScrollToTop";
import { logEvent } from "firebase/analytics";
import { trackBeginCheckout, trackPurchase } from "../../analytics/track";
import checkUserSignedIn from "../../util/AuthUtil";
import sendOrderEmail from "../../util/OrderNotification";
import Seo from "../../components/Seo";

import { routeMeta } from "../../seo/staticRoutes";
export default function Cart() {
  const [address, setAddress] = useState("");
  const [phone, setPhone] = useState("");
  const [pincode, setPincode] = useState("");
  const [fullName, setFullName] = useState("");
  // Optional. Collected in the form rather than extracted from a forced Google
  // sign-in, which used to be the only way an order could carry an address.
  const [email, setEmail] = useState("");
  const [showError, setShowError] = useState("");
  const [totalPrice, setTotalPrice] = useState("0");
  const [authUser, setAuthUser] = useState(null);

  const navigate = useNavigate();
  const inputRef = useRef(null);


  const productsRef = collection(db, "orders");
  const [paymentMethod, setPaymentMethod] = useState("");
  const [placingOrder, setPlacingOrder] = useState(false);

  const handleOptionChange = (event) => {
    setPaymentMethod(event.target.value);
    setShowError("")
  };

  const increaseQty = (cartProductId, currentQty) => {
    const newQty = currentQty + 1;
    dispatch(updateQuantity({ id: cartProductId, quantity: newQty }));
  };

  const decreaseQty = (cartProductId, currentQty) => {
    const newQty = Math.max(currentQty - 1, 1);
    dispatch(updateQuantity({ id: cartProductId, quantity: newQty }));
  };

  // loginWithGoogleBeforeOrderPlacing() lived here and gated every order behind
  // a Google popup. Removed with guest checkout — signing in is still offered
  // at /login for anyone who wants their order history, but it is no longer a
  // condition of buying anything.

  /** Readable order summary for WhatsApp — uses real product names, not slugs. */
  function buildWhatsAppMessage(order, charges, codCharges) {
    const lines = ["Hello NT Sticks, I'd like to place this order:", ""];

    cartProducts.forEach((item, index) => {
      lines.push(
        `${index + 1}. ${item.product_name} — qty ${item.quantity} — ₹${
          item.price * item.quantity
        }`
      );
    });

    lines.push("");
    lines.push(`Delivery: ₹${charges}`);
    if (codCharges) lines.push(`COD charge: ₹${codCharges}`);
    lines.push(`Total: ₹${order.totalPrice}`);
    lines.push("");
    lines.push(`Name: ${fullName}`);
    lines.push(`Phone: ${phone}`);
    lines.push(`Address: ${address}`);
    lines.push(`Pincode: ${pincode}`);
    if (paymentMethod) lines.push(`Payment: ${paymentMethod}`);

    return lines.join("\n");
  }

  const placeOrder = (typeOfOrder) => {
    if (!checkDetails()) return;
    let charges = parseInt(totalAmounts) > 200 ? deliveryCharge : 50;
    let codCharges = paymentMethod === "Cash on Delivery"?30:0
    // Both branches below are a real intent to buy, so WhatsApp orders are not
    // invisible to the funnel just because they finish off-site.
    trackBeginCheckout(cartProducts, totalAmounts + charges + codCharges);
    const dataToPlaceOrder = {
      totalPrice: totalAmounts + charges+codCharges,
      itemsList: [],
    };
    for (let i = 0; i < cartProducts.length; i++) {
      let obj = {
        itemName: cartProducts[i].product_name_key,
        quantity: cartProducts[i].quantity,
      };
      dataToPlaceOrder["itemsList"].push(obj);
    }
    switch (typeOfOrder) {
      case "api":
        // Charges are computed here, so they're handed down for the alert email
        // rather than recalculated against a cart that may already be cleared.
        placeOrderViaApi(dataToPlaceOrder, { charges, codCharges });
        break;

      case "whatsapp":
        // Was JSON.stringify(...), so the customer saw raw machine output with
        // slug names at the exact moment they were committing to buy.
        window.open(
          "https://api.whatsapp.com/send?phone=916264208349" +
            "&text=" +
            encodeURIComponent(buildWhatsAppMessage(dataToPlaceOrder, charges, codCharges)),
          "_blank"
        );
        break;

      case "call":
        document.location.href = "tel:+916264208349";
        break;
    }
  };

  const dispatch = useDispatch();
  const {
    data: cartProducts,
    totalAmounts,
    deliveryCharge,
  } = useSelector((state) => state.cart);

  useEffect(() => {
    logEvent(analytics, "view_cart", { value: totalAmounts, currency: "INR" });
    checkUserSignedIn(auth, setAuthUser);
    setTotalPrice(String(totalAmounts + deliveryCharge));
    dispatch(getCartTotal());
  }, [useSelector((state) => state.cart)]);

  const handleRemoveItem = (itemId) => {
    dispatch(removeItem({ id: itemId }));
  };

  function setRefOnField(){
    if (inputRef.current) {
      inputRef.current.focus(); // Set focus on the input element
    }
  }

  function checkDetails() {
    if (!address || !phone || !fullName || !pincode) {
      setShowError("Complete the neccessary details");
      setRefOnField()
      return;
    } else {
      if(!paymentMethod){
        setShowError("Please select delivery type")
        setRefOnField()
        return;
      }
      // Optional, so an empty box is fine — but a typo in one that was filled
      // in silently costs the customer their receipt.
      if (email && !/^\S+@\S+\.\S+$/.test(email)) {
        setShowError("That email address doesn't look right. Correct it, or clear the box to order without one.");
        setRefOnField();
        return;
      }
      setShowError("")
      return true;
    }
  }

  const placeOrderViaApi = async (data, breakdown = { charges: 0, codCharges: 0 }) => {
    if (!checkDetails()) {
      logEvent(analytics, "checkout_validation_failed", { value: totalAmounts });
      return;
    }
    if (placingOrder) return;

    setPlacingOrder(true);
    setShowError("");

    try {
      const res = await addDoc(productsRef, {
        Address: address,
        // The typed address wins: someone can be signed in with one Google
        // account and want the receipt somewhere else.
        email: email || auth?.currentUser?.email || "",
        customerName: fullName,
        pincode: pincode,
        phone: phone,
        isRepeat: false,
        orderData: data,
        promocode: "",
        time: new Date().toLocaleString("en-IN", { timeZone: "Asia/Kolkata" }),
      });

      // Only confirm once the order is genuinely stored. Previously this
      // navigated to /confirmation even when the write threw, so a customer
      // could be told their order was placed when no record existed.
      // Fired only after the Firestore write resolves, so revenue reported to
      // Ads Manager and GA4 matches the revenue in the order book. res.id is the
      // deduplication key if the pixel ever also fires server-side.
      trackPurchase({
        orderId: res.id,
        items: cartProducts,
        value: data.totalPrice,
        shipping: breakdown.charges + breakdown.codCharges,
      });

      // Alert email is deliberately not awaited: the order is already safe in
      // Firestore, so a slow or failing send must not hold up the confirmation
      // screen. Built before clearCart() while cartProducts still has the real
      // product names — data.itemsList only carries slugs.
      const orderForEmail = {
        orderId: res.id,
        customerName: fullName,
        phone,
        email: email || auth?.currentUser?.email || "",
        address,
        pincode,
        paymentMethod,
        items: cartProducts.map((item) => ({
          name: item.product_name,
          quantity: item.quantity,
          lineTotal: item.price * item.quantity,
          image: item.product_img,
        })),
        deliveryCharge: breakdown.charges,
        codCharge: breakdown.codCharges,
        total: data.totalPrice,
        cc:"ntincensesticks@gmail.com",
      };

      // One email, to the customer with NT Sticks BCC'd — or to NT Sticks
      // alone when no address was given. Deliberately not awaited: the order is
      // already safe in Firestore, so a slow or failing send must not hold up
      // the confirmation screen.
      sendOrderEmail(orderForEmail).then((sent) => {
        if (!sent) {
          logEvent(analytics, "order_email_failed", { order_id: res.id });
        }
      });

      dispatch(clearCart());
      navigate("/confirmation", {
        state: {
          orderId: res.id,
          total: data.totalPrice,
          paymentMethod,
          email: orderForEmail.email,
        },
      });
    } catch (err) {
      console.error("Order could not be saved", err);
      logEvent(analytics, "order_failed", { value: totalAmounts });
      setShowError(
        "We couldn't place your order just now — nothing has been charged. Please check your connection and try again, or send this order on WhatsApp and we'll confirm it for you."
      );
      setRefOnField();
    } finally {
      setPlacingOrder(false);
    }
  };

  const emptyCartMsg = (
    <div className="modern-cart-container">
      {/* Cart Header */}
      <div className="cart-header">
        <div className="container-fluid">
          <div className="row px-xl-5">
            <div className="col-12">
              <div className="cart-breadcrumb">
                <a href="/" className="breadcrumb-link">Home</a>
                <i className="fas fa-chevron-right"></i>
                <span className="breadcrumb-current">Cart</span>
              </div>
              <div className="cart-title-section">
                <h1 className="cart-title">Your Shopping Cart</h1>
                <p className="cart-subtitle">Review your selected items and proceed to checkout</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Empty Cart State */}
      <div className="empty-cart-section">
        <div className="container-fluid">
          <div className="row px-xl-5 justify-content-center">
            <div className="col-lg-6 col-md-8">
              <div className="empty-cart-content">
                <div className="empty-cart-icon">
                  <i className="fas fa-shopping-cart"></i>
                </div>
                <h3>Your cart is empty</h3>
                <p>Looks like you haven't added any items to your cart yet. Start shopping to fill it up!</p>
                <a href="/shop" className="btn-shop-now">
                  <i className="fas fa-shopping-bag mr-2"></i>
                  Start Shopping
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  return (
    <>
      <Seo {...routeMeta("/cart")} />
      {cartProducts.length === 0 ? (
        emptyCartMsg
      ) : (
        <div className="modern-cart-container">
          {/* Cart Header */}
          <div className="cart-header">
            <div className="container-fluid">
              <div className="row px-xl-5">
                <div className="col-12">
                  <div className="cart-breadcrumb">
                    <a href="/" className="breadcrumb-link">Home</a>
                    <i className="fas fa-chevron-right"></i>
                    <span className="breadcrumb-current">Cart</span>
                  </div>
                  <div className="cart-title-section">
                    <h1 className="cart-title">Your Shopping Cart</h1>
                    <p className="cart-subtitle">Review your selected items and proceed to checkout</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Cart Content */}
          <div className="cart-content">
            <div className="container-fluid">
              <div className="row px-xl-5">
                <div className="col-lg-8">
                  <div className="cart-items-section">
                    <div className="cart-items-header">
                      <h4>
                        <i className="fas fa-shopping-cart mr-2"></i>
                        Cart Items ({cartProducts.length})
                      </h4>
                    </div>
                    
                    <div className="cart-items-list">
                      {cartProducts.map((cartProduct, i) => (
                        <div key={i} className="cart-item-card">
                          <div className="cart-item-image">
                            <img
                              src={cartProduct.product_img}
                              alt={cartProduct.product_name}
                              className="product-image"
                            />
                          </div>
                          
                          <div className="cart-item-details">
                            <h5 className="product-name">{cartProduct.product_name}</h5>
                            <div className="product-price">
                              <span className="price-label">Price:</span>
                              <span className="price-value">₹{cartProduct.price}</span>
                            </div>
                          </div>
                          
                          <div className="cart-item-quantity">
                            <label className="quantity-label">Quantity</label>
                            <div className="quantity-controls">
                              <button
                                className="quantity-btn decrease"
                                onClick={() =>
                                  decreaseQty(
                                    cartProduct.id,
                                    cartProduct.quantity
                                  )
                                }
                              >
                                <i className="fas fa-minus"></i>
                              </button>
                              <span className="quantity-value">{cartProduct.quantity || 1}</span>
                              <button
                                className="quantity-btn increase"
                                onClick={() =>
                                  increaseQty(
                                    cartProduct.id,
                                    cartProduct.quantity
                                  )
                                }
                              >
                                <i className="fas fa-plus"></i>
                              </button>
                            </div>
                          </div>
                          
                          <div className="cart-item-total">
                            <label className="total-label">Total</label>
                            <span className="total-value">₹{cartProduct.totalPrice}</span>
                          </div>
                          
                          <div className="cart-item-remove">
                            <button
                              className="remove-btn"
                              onClick={() => handleRemoveItem(cartProduct.id)}
                              title="Remove item"
                            >
                              <i className="fas fa-trash"></i>
                            </button>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>

                <div className="col-lg-4">
                  <div className="checkout-section">
                    <div className="checkout-header">
                      <h4>
                        <i className="fas fa-credit-card mr-2"></i>
                        Checkout Details
                      </h4>
                    </div>

                    <form className="checkout-form">
                      {/* Delivery Information */}
                      <div className="form-section">
                        <h5 className="section-title">
                          <i className="fas fa-map-marker-alt mr-2"></i>
                          Delivery Information
                        </h5>
                        
                        <div className="form-row">
                          <div className="form-group">
                            <label>Full Name</label>
                            <input
                              type="text"
                              className="form-control modern-input"
                              placeholder="Enter your full name"
                              onChange={(e) => setFullName(e.target.value)}
                            />
                          </div>
                          <div className="form-group">
                            <label>Phone Number</label>
                            <input
                              type="tel"
                              className="form-control modern-input"
                              placeholder="Enter your phone number"
                              onChange={(e) => setPhone(e.target.value)}
                            />
                          </div>
                        </div>

                        <div className="form-row">
                          <div className="form-group">
                            <label>Delivery Address</label>
                            <input
                              type="text"
                              className="form-control modern-input"
                              placeholder="Enter delivery address"
                              onChange={(e) => setAddress(e.target.value)}
                              ref={inputRef}
                            />
                          </div>
                          <div className="form-group">
                            <label>Pincode</label>
                            <input
                              type="number"
                              className="form-control modern-input"
                              placeholder="Enter pincode"
                              onChange={(e) => setPincode(e.target.value)}
                            />
                          </div>
                        </div>

                        <div className="form-row">
                          <div className="form-group">
                            <label>
                              Email <span className="field-optional">(optional)</span>
                            </label>
                            <input
                              type="email"
                              className="form-control modern-input"
                              placeholder="So we can send your order details"
                              value={email}
                              onChange={(e) => setEmail(e.target.value)}
                            />
                          </div>
                        </div>

                        {address && (
                          <div className="delivery-address-preview">
                            <i className="fas fa-map-marker-alt mr-2"></i>
                            <span>Delivering to: {address}, {pincode}</span>
                          </div>
                        )}
                      </div>

                      {/* Payment Method */}
                      <div className="form-section">
                        <h5 className="section-title">
                          <i className="fas fa-credit-card mr-2"></i>
                          Payment Method
                        </h5>
                        
                        <div className="payment-options">
                          <label className={`payment-option ${paymentMethod === "Prepayment" ? "selected" : ""}`}>
                            <input
                              type="radio"
                              value="Prepayment"
                              checked={paymentMethod === "Prepayment"}
                              onChange={handleOptionChange}
                              className="payment-radio"
                            />
                            <div className="payment-option-content">
                              <i className="fas fa-qrcode payment-icon"></i>
                              {/* Was "Online Payment", which promised a checkout
                                  that charges the card. Nothing is collected
                                  here — the customer pays by UPI afterwards —
                                  so the label now says so. Replace this whole
                                  option when Razorpay goes in. */}
                              <span>Pay by UPI</span>
                              <span className="payment-note">after placing the order</span>
                            </div>
                          </label>
                          
                          <label className={`payment-option ${paymentMethod === "Cash on Delivery" ? "selected" : ""}`}>
                            <input
                              type="radio"
                              value="Cash on Delivery"
                              checked={paymentMethod === "Cash on Delivery"}
                              onChange={handleOptionChange}
                              className="payment-radio"
                            />
                            <div className="payment-option-content">
                              <i className="fas fa-money-bill-wave payment-icon"></i>
                              <span>Cash on Delivery</span>
                              <span className="cod-charges">(+₹30)</span>
                            </div>
                          </label>
                        </div>
                      </div>
                    </form>

                    {showError && (
                      <div className="error-message">
                        <i className="fas fa-exclamation-triangle mr-2"></i>
                        {showError}
                      </div>
                    )}

                    {/* Order Summary */}
                    <div className="order-summary">
                      <h5 className="summary-title">
                        <i className="fas fa-receipt mr-2"></i>
                        Order Summary
                      </h5>
                      
                      <div className="summary-details">
                        <div className="summary-row">
                          <span>Subtotal</span>
                          <span>₹{totalAmounts}</span>
                        </div>
                        <div className="summary-row">
                          <span>Shipping</span>
                          <span>₹{parseInt(totalAmounts) > 200 ? deliveryCharge : "50"}</span>
                        </div>
                        {paymentMethod === "Cash on Delivery" && (
                          <div className="summary-row">
                            <span>COD Charges</span>
                            <span>₹30</span>
                          </div>
                        )}
                        <div className="summary-row total-row">
                          <span>Total</span>
                          <span>₹{totalAmounts + (parseInt(totalAmounts) > 200 ? deliveryCharge : 50) + (paymentMethod === "Cash on Delivery" ? 30 : 0)}</span>
                        </div>
                      </div>

                      {/* Place Order Buttons */}
                      <div className="order-buttons">
                        <button
                          // Guest checkout. This used to open a Google sign-in
                          // popup first and only order if it succeeded, which
                          // cost every customer unwilling to attach a Google
                          // account to the purchase — and everyone in an
                          // Instagram or WhatsApp in-app browser, where
                          // signInWithPopup is routinely blocked outright. The
                          // form already collects everything an order needs.
                          onClick={() => placeOrder("api")}
                          className="btn-place-order primary"
                          disabled={placingOrder}
                        >
                          <i
                            className={`fas ${
                              placingOrder ? "fa-spinner fa-spin" : "fa-shopping-cart"
                            } mr-2`}
                          ></i>
                          {placingOrder ? "Placing order…" : "Place Order"}
                        </button>
                        
                        <div className="alternative-orders">
                          <button
                            onClick={() => placeOrder("whatsapp")}
                            className="btn-place-order whatsapp"
                          >
                            <i className="fab fa-whatsapp mr-2"></i>
                            Order via WhatsApp
                          </button>
                          <button
                            onClick={() => placeOrder("call")}
                            className="btn-place-order call"
                          >
                            <i className="fas fa-phone mr-2"></i>
                            Order via Call
                          </button>
                        </div>
                      </div>
                    </div>

                    {/* Shown only for UPI, and only once there is an amount to
                        show. An unexplained QR with no figure on it was the
                        reason prepaid orders arrived unpaid and unmatched. */}
                    {paymentMethod === "Prepayment" && (
                      <div className="payment-qr">
                        <h6>Pay ₹{totalAmounts + (parseInt(totalAmounts) > 200 ? deliveryCharge : 50)} by UPI</h6>
                        <p className="payment-qr-note">
                          Place the order first — we'll show you your order number
                          on the next screen. Scan this code, pay the amount above,
                          and put that order number in the payment note so we can
                          match it to your order.
                        </p>
                        <img
                          src="../../assets/nt/paytm.webp"
                          alt="UPI payment QR code for NT Sticks"
                          className="qr-code"
                        />
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      <ScrollToTop />
      {/* <RenderScript resourceUrl={gpayScript} onGooglePayLoaded={onGooglePayLoaded} /> */}
    </>
  );
}
